import React from 'react';
import PropTypes from 'prop-types';

import { BreedSearchResultPropTypes } from 'dpl/shared/utils/customPropTypes';
import LoadingWrapper from 'dpl/components/LoadingWrapper';
import BreedSearchResultsListV2 from 'dpl/components/BreedSearch/v2/BreedSearchResultsListV2';

import { BREED_PROFILES, BREED_TYPES } from '../util';

const mobileBreedSearchResultsDefaultPropAnalytics = {};
/** @param {any} props */
export default function MobileBreedSearchResults({
  analytics = mobileBreedSearchResultsDefaultPropAnalytics,
  breeds,
  query,
  onSelectItem = null,
  breedType = 'All'
}) {
  return (
    <div className="MobileBreedSearchResults bg-white h-100">
      <LoadingWrapper isLoading={!query && breeds.length === 0}>
        <BreedSearchResultsListV2
          analytics={analytics}
          breeds={breeds}
          query={query}
          onSelectItem={onSelectItem}
          breedType={breedType}
        />
      </LoadingWrapper>
    </div>
  );
}

MobileBreedSearchResults.propTypes = {
  analytics: PropTypes.shape({
    origin_view: PropTypes.string,
    origin_view_feature: PropTypes.string
  }),
  query: PropTypes.string.isRequired,
  breeds: PropTypes.arrayOf(PropTypes.shape(BreedSearchResultPropTypes))
    .isRequired,
  onSelectItem: PropTypes.func,
  breedType: PropTypes.oneOf([BREED_TYPES.ALL, BREED_PROFILES])
};
